import { ChevronDown, Upload } from 'lucide-react';
import { usePopover } from '@/components/apps/usePopover';
import type { ImportSource } from './TableImportDrawer';

const ITEMS: Array<{ source: ImportSource; label: string }> = [
  { source: 'file', label: 'Fichier CSV' },
  { source: 'paste', label: 'Coller un tableau' },
  { source: 'app', label: 'Résultats d’une app' },
];

/** One « Importer » button (04/11/2026) that opens the kinds of import. */
export const ImportMenu = ({ onChoose, primary = false }: { onChoose: (source: ImportSource) => void; primary?: boolean }) => {
  const { open, setOpen, ref } = usePopover();
  return (
    <div ref={ref} className="relative">
      <button type="button" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)}
        className={primary
          ? 'inline-flex h-9 items-center gap-2 rounded-lg bg-domino-aubergine px-4 text-sm font-medium text-white shadow-[0_10px_22px_rgba(74,31,78,0.18)] hover:bg-domino-prune'
          : 'inline-flex items-center gap-2 rounded-xl border border-domino-cardBorder bg-domino-white px-3 py-1.5 text-sm text-domino-ink hover:border-domino-aubergine'}>
        <Upload className="h-4 w-4" /> Importer <ChevronDown className="h-3.5 w-3.5" />
      </button>
      {open && (
        <div role="menu" className="absolute right-0 z-30 mt-1 w-56 rounded-xl border border-domino-cardBorder bg-domino-white p-1 shadow-lg">
          {ITEMS.map((item) => (
            <button key={item.source} type="button" role="menuitem" onClick={() => { setOpen(false); onChoose(item.source); }}
              className="block w-full rounded-lg px-3 py-2 text-left text-sm text-domino-ink hover:bg-domino-plumTint hover:text-domino-aubergine">
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
